import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index"

const state = {
    dataWasLoaded: false,
    registrationData: null,
    loginData: null,
}

const getters = {
    dataWasLoaded: state => state.dataWasLoaded,
    registrationData: state => state.registrationData,
    loginData: state => state.loginData,
}

const actions = {
    getAuthData ({ commit }) {
        let params = {
            'handler': 'auth',
            'func': 'getAuthData'
        }
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setRegistrationData', responseData.data.data.registration);
            commit('setLoginData', responseData.data.data.login);
            commit('setDataWasLoaded', true);
        });
    },

    registerUser ({ commit }, fieldsValue) {
        let params = {
            'handler': 'auth',
            'func': 'registerUser',
            'fieldsValue': fieldsValue
        }

        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            let data = responseData.data.data;
            if (data.status == 'success') {
                _u.redirect(data.redirect ? data.redirect : window.location.pathname);
            } else {
                commit('setRegistrationData', responseData.data.data);
            }
        });
    },

    loginUser ({ commit }, fieldsValue) {
        let params = {
            'handler': 'auth',
            'func': 'loginUser',
            'fieldsValue': fieldsValue
        }
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            let data = responseData.data.data;
            if (data.status == 'success') {
                _u.redirect(data.redirect ? data.redirect : window.location.pathname);
            } else {
                commit('setLoginData', responseData.data.data);
            }
        });
    },

    recoveryPassword ({ commit }, email) {
        let params = {
            'handler': 'auth',
            'func': 'recoveryPassword',
            'fieldsValue': email
        }
        _u.requestHttp('post', APP.ajax_endpoint, params, (responseData) => {
            let data = responseData.data.data;
            if (data.status == 'success') {
                // _u.redirect(data.redirect ? data.redirect : '');
            } else {
                commit('setLoginData', responseData.data.data);
            }
        });
    },

}

const mutations = {
    setDataWasLoaded (state, dataWasLoaded) {
        state.dataWasLoaded = dataWasLoaded;
    },
    setRegistrationData (state, registrationData) {
        state.registrationData = registrationData;
    },
    setLoginData (state, loginData) {
        state.loginData = loginData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
